/**
 * useLogoField — `vm` + `actions` do campo Logo (contrato `logoField.vm.js` @v1) e da biblioteca em modo 'logo'.
 * docs/PLANO-EXECUCAO-MIDIA.md TODO 8.1 — no `SiteForm`, o `Controller` de `identity` passa a renderizar:
 *
 *   const { vm, actions, library } = useLogoField({ identity: field.value, onChange: field.onChange });
 *   return <><LogoFieldView vm={vm} actions={actions} /><MediaLibrary vm={library.vm} actions={library.actions} /></>;
 *
 * Escolher grava `avatarAssetId` + `avatarOrigin` e limpa `avatarUrl` (o endereço antigo) — `logoFieldModel.js`.
 */
import { useCallback, useMemo, useState } from 'react';
import useMediaLibrary from './useMediaLibrary';
import useContaDoEditor from './useContaDoEditor';
import { montarVm, escolherLogo, tirarLogo } from './logoFieldModel.js';

export default function useLogoField({ identity, onChange }) {
  const { donoId } = useContaDoEditor();
  const [bibliotecaAberta, setBibliotecaAberta] = useState(false);
  const fechar = useCallback(() => setBibliotecaAberta(false), []);

  const library = useMediaLibrary({
    open: bibliotecaAberta,
    mode: 'logo',
    logoAtual: identity?.avatarAssetId ?? null,
    onConfirm: ([foto]) => { if (foto) onChange(escolherLogo(identity ?? {}, foto)); setBibliotecaAberta(false); },
    onClose: fechar,
  });

  const vm = useMemo(() => montarVm(identity ?? {}, donoId), [identity, donoId]);
  const actions = useMemo(() => ({
    onChoose: () => setBibliotecaAberta(true),
    onRemove: () => onChange(tirarLogo(identity ?? {})),
  }), [identity, onChange]);

  return { vm, actions, library };
}
